var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"type":"narrow"}},[(!_vm.loadingState)?_c('div',[_c('Row',{staticStyle:{"margin-bottom":"15px"}},[_c('Profile'),_c('TaxSetting')],1),_c('Row',{staticStyle:{"margin-bottom":"15px"}},[_c('PrefixSetting')],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }